import { api } from "@/api";
import type { CompanyDetails } from "@/types/domain";

export const fetchCompanyDetails = async (companyId: string): Promise<CompanyDetails> => {
  const response = await api.get<CompanyDetails>("/company/details", {
    params: { companyId },
  });
  return response.data;
};
